
  import React from "react"
  import Component from "/Users/jethrolai/workspace/git.jethrolai.com/jethrolai.com/src/layouts/index.js"
  import data from "/Users/jethrolai/workspace/git.jethrolai.com/jethrolai.com/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js